import { render, staticRenderFns } from "./TableWidget.vue?vue&type=template&id=6df6fbb4&scoped=true&"
import script from "./TableWidget.vue?vue&type=script&lang=ts&"
export * from "./TableWidget.vue?vue&type=script&lang=ts&"
import style0 from "./TableWidget.vue?vue&type=style&index=0&id=6df6fbb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df6fbb4",
  null
  
)

export default component.exports